import { NgModule,Component} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { PersonaComponent } from './components/signup/persona/persona.component';
import { EmpresaComponent } from './components/signup/empresa/empresa.component';
import { ProfileComponent } from './profile/profile.component';
import { BeforeLoginService } from './Services/before-login.service';
import { AfterLoginService } from './Services/after-login.service';
import { AdminComponent } from './components/admin/admin.component';
import { NuevoEnvioComponent } from './components/nuevo-envio/nuevo-envio.component';
import { Error404Component } from './components/error404/error404.component';
import { CambiarPasswordComponent } from './components/cambiar-password/cambiar-password.component';
import { MotorizadoComponent } from './motorizado/motorizado.component';
import { ResumeComponent } from './components/resume/resume.component';
import { RegionComponent } from './region/region.component';
import { MapAdminComponent } from './components/map-admin/map-admin.component';
import { VerUsuariosComponent } from './components/ver-usuarios/ver-usuarios.component';

const appRoutes: Routes =[
  {
    path : '',
    component : LoginComponent,
    canActivate:[BeforeLoginService]
  },
  
  {
    path : 'culqi',
    component : ResumeComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'login',
    component : LoginComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'cambiar-password',
    component : CambiarPasswordComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'signup',
    component : SignupComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'signup/persona',
    component : PersonaComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'signup/empresa',
    component : EmpresaComponent,
    canActivate:[BeforeLoginService]
  },
  {
    path : 'profile',
    component : ProfileComponent,
    canActivate:[AfterLoginService]
  },
  {
    path:'profile/usuarios',
    component: VerUsuariosComponent,
    canActivate:[AfterLoginService]
  },
  {
    path : 'motorizado',
    component : MotorizadoComponent,
    canActivate:[AfterLoginService]
  },
  
  {
    path : 'admin',
    component : AdminComponent,
    canActivate:[AfterLoginService]
  },
  {
    path : 'profile/pedido',
    component : NuevoEnvioComponent,
    canActivate:[AfterLoginService]
  },
   {
    path : 'profile/map-admin',
    component : MapAdminComponent,
    canActivate:[AfterLoginService]
  },
  {
    path : 'escoge-tu-region',
    component : RegionComponent,
    canActivate:[AfterLoginService]
  },
  { path: '**', 
    component: Error404Component
  },
  

]

@NgModule({
  imports: [  
    RouterModule.forRoot(appRoutes, { useHash: false })
  ],
  exports :[RouterModule]
})
export class AppRoutingModule { }
